module.exports = __webpack_public_path__ + "img/frame (220).038f8c5d.jpg";